import { AdminAbManager } from "./AdminAbManager";


export function loadAdminAbManagement(){
    new AdminAbManager()
}